import { render } from "./icon-info-orange.vue?vue&type=template&id=1461a472"
const script = {}

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__